import { createI18n } from 'vue-i18n'
import { defaultLang, getLocale } from 'src/common/functions'
import { useUserAuthStore } from 'src/stores/user/auth'

let i18nObject = null

export default (ctx) => {
  const { app } = ctx

  const locale = useUserAuthStore().getUserLanguage || getLocale()

  const repeatLoad = (langIso, count = 1, defaultL = false) =>
    import(/* webpackChunkName: "lang-[request]" */ `../i18n/${langIso}/index.js`)
      .then((res) => {
        i18nObject = createI18n({
          legacy: false,
          locale,
          globalInjection: true,
          fallbackLocale: defaultLang,
          messages: {
            [langIso]: res.default,
          },
          pluralRules: {
            ru: function (choice, choicesLength) {
              if (choice === 0) {
                return 0
              }

              const teen = choice > 10 && choice < 20
              const endsWithOne = choice % 10 === 1

              if (choicesLength < 4) {
                return !teen && endsWithOne ? 1 : 2
              }
              if (!teen && endsWithOne) {
                return 1
              }
              if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
                return 2
              }

              return choicesLength < 4 ? 2 : 3
            },
          },
        })

        app.use(i18nObject)
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(`[CAS] Error lang loaded: ${count}`, err)
        if (defaultL) {
          return count > 0 ? repeatLoad(defaultLang, count - 1, true) : null
        }
        return count > 0 ? repeatLoad(langIso, count - 1) : repeatLoad(defaultLang, 5, true)
      })

  return repeatLoad(locale, 5)
}

export { i18nObject }
